// @flow
import type { Option, Usage } from 'digicel-kaizen-library';
import { sortBy } from 'lodash';

export const sortOptionsInOfferById = (offer: Object): Object => {
  const optionsSortedById = sortBy(offer.options, 'id');

  return {
    ...offer,
    options: optionsSortedById,
  };
};

const ORDER = ['SOCIAL', 'DATA', 'VOICE', 'SMS'];

const getOrderingValue = (optionName: string): number => {
  let index = ORDER.findIndex(name => optionName.startsWith(name));
  if (index !== -1) {
    return index;
  }

  index = ORDER.findIndex(name => optionName.includes(name));
  if (index !== -1) {
    return index + ORDER.length;
  }

  // push the not found ones at the end
  return 2 * ORDER.length;
};

export const sortByDataVoiceSMS = (a: any, b: any, sortBy: ?(any) => string): number => {
  const aToCompare = sortBy ? sortBy(a) : a;
  const bToCompare = sortBy ? sortBy(b) : b;
  const aIndex = getOrderingValue(aToCompare);
  const bIndex = getOrderingValue(bToCompare);
  if (aIndex === bIndex) {
    // alphabetical sort
    return aToCompare.localeCompare(bToCompare);
  }
  return aIndex - bIndex;
};

export const usagesComparator = (a: Usage, b: Usage): number => sortByDataVoiceSMS(a, b, usage => usage.label);

export const sortByDataVoiceSMSComparatorFactory = (sortBy?: ?(any) => string) => (a: Object, b: Object) =>
  sortByDataVoiceSMS(a, b, sortBy);

export const sortOptionsByKey = (options: Object[], key: string): Object[] => {
  const newOptionsReferences = [...options];
  return newOptionsReferences.sort((option1, option2) => sortByDataVoiceSMS(option1[key], option2[key]));
};

export const sortOptions = (options: { [string]: Option }[]): Object[] => {
  return sortOptionsByKey(options, 'name');
};
